import DataProvider from "./DataProvider";
import {VenueDataProvider} from "./VenueDefinition";

export default class SessionizeDataProvider extends DataProvider {
    sessions: BaseSession[] = []

    constructor(public venueDataProvider:VenueDataProvider) {
        super();
        this.refreshData()
    }

    callRefresh() {
        this.refreshData()
    }

    private refreshData() {
        let sid = this.venueDataProvider.getValue("sessionizeId");
        if(sid) {
            let dataUrl = this.dataUrl();

            fetch(dataUrl)
                .then(response => response.json())
                .then(sessionizeData => {
                    this.setSessionData(sessionizeData)
                })
        }
    }

    private dataUrl(): string {
        return `https://sessionize.com/api/v2/${this.venueDataProvider.getValue("sessionizeId")}/view/Sessions`
    }

    private setSessionData(sessionData: any) {
        this.sessions = sessionData[0].sessions
        this.dataLoaded = true
        this.call()
        this.dataLoaded = true

    }

    findCurrentSessionInfo(roomId: number): BaseSession | null {
        const v = this.sessions.find((sess) => sess.roomId === roomId)
        return v ? v : null
    }
}

export interface BaseSession {
    id: string,
    title: string,
    description: string,
    startsAt: string,
    endsAt: string,
    speakers: BaseSpeaker[],
    roomId: number,
    room: string
}

interface BaseSpeaker {
    id: string,
    name: string
}

/*
"sessions": [
      {
        "questionAnswers": [],
        "id": "162213",
        "title": "Welcome Address",
        "description": "Welcome to droidconSF 2019! Brief intro to all things going on at droidcon Global and a few words from our program committee co-chairs.",
        "startsAt": "2019-11-25T09:00:00",
        "endsAt": "2019-11-25T09:20:00",
        "isServiceSession": false,
        "isPlenumSession": true,
        "speakers": [
          {
            "id": "275e8c46-52ca-4bce-aa05-6460d01bbe03",
            "name": "Greg Fawson"
          },
          {
            "id": "6a3de662-ef86-4c62-bb68-2f7ebe607f76",
            "name": "Ty Smith"
          },
          {
            "id": "da0d0b74-71cf-4ac6-941b-94626dd92bf0",
            "name": "Joaquim Verges"
          }
        ],
        "categories": [],
        "roomId": 9739,
        "room": "Robertson 1"
      },
      {
        "questionAnswers": [],
        "id": "156488",
        "title": "Opening Keynote: Android Then & Now",
        "description": "Android development has come a long way since 1.0. How did we get here? And now that we're here, what do we do next?\r\nThis talk will go over the landscape of Android development through the years and the releases, and talk about what Android platform priorities are now, and what that means for de
 */
